import React, { useState, useRef, useEffect } from 'react';
import gsap from 'gsap';

import Image from '../Image';
import styles from './GridItem.module.css';

const getRandomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);

const GridItem = ({ posY, posX, index, item }) => {
  const ref = useRef();
  const xMultiplier = useRef(getRandomNumber(1, 3));
  const yMultiplier = useRef(getRandomNumber(1, 3));
  const [translationValues, setTranslationVals] = useState({ tx: 0, ty: 0 });

  useEffect(() => {
    const render = () => {
      const newTranslationVals = {
        tx: gsap.utils.interpolate(translationValues.tx, posX * (xMultiplier.current * 0.01), 0.5),
        ty: gsap.utils.interpolate(translationValues.ty, posY * (yMultiplier.current * 0.01), 0.5)
      };
      gsap.to(ref.current, { ease: 'easeOut', x: newTranslationVals.tx, y: newTranslationVals.ty });
      setTranslationVals(newTranslationVals);
    };
    requestAnimationFrame(render);
  }, [posX, posY]);

  return (
    <div ref={ref} className={`${styles[`pos${index + 1}`]} relative`}>
      <Image item={item} />
    </div>
  );
};

export default GridItem;
